import axios from "axios";
import config from "../../config/config";
import * as mocks from "./user.mocks";
import { UserProfile, UserProfileResponse } from "./user.interfaces";

const API_URL = `${config.apiBaseUrl}/user`;

const apiGetUserProfile = async (): Promise<UserProfileResponse> => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get<UserProfile>(`${API_URL}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return [true, response.data];
  } catch (error) {
    console.error("Failed to fetch user profile:", error);
    return [false, null];
  }
};

export const getUserProfile = async (): Promise<UserProfileResponse> => {
  return config.useRealApi ? apiGetUserProfile() : mocks.getUserProfile();
};
